var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper signup-page-wrp"},[_c('div',{staticClass:"signup-page signin-page"},[_c('div',{staticClass:"signup-page-right"},[_c('div',{staticClass:"align",staticStyle:{"width":"50%","margin":"0 auto"}},[_c('img',{attrs:{"src":"/public/images/loader.gif","alt":""}})])])])])
}]

export { render, staticRenderFns }